/* eslint-disable no-debugger */
import axios from "axios";
import { tokenHelper } from "./token_helper";
import { toast } from "react-toastify";
import { useAccessDeniedStore } from "../Modal/AccessDeniedStore";
import i18n from "../../i18n";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
export const axiosHelper = axios.create();

// Axios Defaults

axiosHelper.defaults.baseURL = baseURL;
axiosHelper.defaults.headers.post["Content-Type"] = "application/json";

// interceptors
axiosHelper.interceptors.request.use(
  (config) => {
    if (!config.headers) return config;
    // const token = tokenHelper.getToken() || null;
    // config.headers.common["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    // alert(error.response.data.message);
    throw error;
  }
);
axiosHelper.interceptors.response.use(
  (response) => {
    return response?.data;
  },
  (error) => {
    // debugger
    const status = error?.response?.status;
    const message = error?.response?.data?.message;
    const suppressToast = error?.config?.suppressToast;

    const isLogin = error?.config?.url?.toLowerCase().includes("login") || error?.config?.url?.toLowerCase().includes("signin");

    if (status === 401 && !isLogin && message?.toLowerCase() !== "invalid password") {
      setTimeout(() => {
        window.location.replace("/logout"); // safer than push to prevent back navigation
      }, 500);

      return; // optionally stop execution
    }

    if (status === 403) {
      useAccessDeniedStore.getState().show();
      throw error;
    }

    // Only show toast if not suppressed
    if (!suppressToast) {
      toast.error(error.response?.data?.message, {
        position: "bottom-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    throw error;
  }
);
